// action 
import OdataReadOnlyActionBase from "@/core/actions/OdataReadOnlyActionBase";
// service
import ClientMenuItemsService from "@/cms/services/ClientMenuItemsService";


class ClientMenuItemsServiceAction extends OdataReadOnlyActionBase {

    constructor( dispatch: any, screenCode:string ) {
        super(dispatch, ClientMenuItemsService, screenCode);
    }

}

export default ClientMenuItemsServiceAction;
